<template>
    <div class="forgetPW">
        <img class="bgImg" src="../../static/img/forget.png" alt />
        <div class="cont">
           <!-- <div class="text">
                申请找回密码的请求已发送您的邮箱中，请查收并设置新密码，
                祝今天开心愉快！
            </div>-->
            <div class="emailInput">
                <input type="text" v-model="tel" placeholder="请输入您的常用手机号" />
            </div>
            <div class="emailInput codeInput">
                <input type="text" v-model="code" placeholder="请输入短信验证码" />
                <div class="code-btn" @click="onClickSend">{{sendText}}</div>
            </div>

            <div class="Btn cursor" @click="onSub()">
                <p>完成</p>
            </div>
        </div>
        <div class="loginWord cursor" @click="$router.go(-1)">下次再来</div>
    </div>
</template>

<script>
    import md5 from '../../commonFunction/md5';
    export default {
        name: "App",
        data() {
            return {
                sendText:'点击发送',
                count:60,
                tel:'',
                code:''
            };
        },
        mounted() {
            document
                .querySelector("body")
                .setAttribute("style", "background-color:#fff");
        },
        methods:{
            //点击发送验证码
            onClickSend(){
                let _this=this;
                if(_this.count != 60){
                    _this.common.vMessage('请等待 '+_this.count+' s','warning');
                    return;
                }
                _this.common.request('api/user/checkTel',{tel:_this.tel},function (res) {
                    if(res.status == 200){
                        let data={
                            tel:_this.tel,
                            sign:md5(md5(_this.tel+_this.common.smsSignKey()))
                        };
                        _this.common.request('code/send',data,function(res){
                            if(res.status == 200){
                                _this.common.vMessage(res.message);
                                let sendIn=setInterval(function(){
                                    _this.sendText=_this.count+' s';
                                    _this.count--;
                                    if(_this.count<=0){
                                        _this.sendText='重新发送';
                                        _this.count=60;
                                        clearInterval(sendIn);//清除定时器
                                    }
                                },1000);

                            }
                        },'post')
                    }
                },'post');
            },
            onSub(){
                let _this = this;
                _this.common.request('api/user/bindTel',{tel: _this.tel,code:_this.code},function (res) {
                    if(res.status == 200){
                        localStorage.setItem("userInfo", JSON.stringify(res.data));
                        _this.$message({
                            message: res.message,
                            type: 'success',
                            duration: 1500,
                            center: true,
                            onClose:function (res) {
                                _this.$router.go(-1);
                            }
                        });
                    }
                },'post');
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/css/index.less";
    .forgetPW {
        width: 600px;
        margin: 50px auto 0;
        .bgImg {
            width: 600px;
            height: 450px;
        }
        .cont {
            background: #f8f8f8;
            .emailInput {
                height: 56px;
                border-bottom: 1px solid #d6d6d6;
                input {
                    color: #7f7f7f;
                    font-size: 16px;
                    height: 53px;
                    background-color: #F8F8F8;
                    text-indent: 10px;
                }
            }
            .text{
                width: 70%;
                margin: 0 auto;
                font-size: 14px;
                text-align: center;
                font-weight:400;
                color:rgba(28,28,28,1);
                line-height:24px;
                padding: 20px 0;
            }
            .Btn {
                height: 56px;
                cursor: pointer;
                .flexSBetween;
                p {
                    font-size: 16px;
                    color: #fff;
                    width: 72px;
                    height: 30px;
                    background: #188DDF;
                    .border-radius(15px);
                    text-align: center;
                    line-height: 30px;
                    margin: 0 auto;
                }
                p:hover{
                    background: #8cc5ff;
                }
            }
        }
    }
    .loginWord{
        width: 100%;
        font-weight:600;
        color:rgba(22,101,147,1);
        line-height:54px;
        text-align: center;
        font-size: 14px;
        cursor: pointer;
    }
    .loginWord:hover{
        text-decoration: underline;
    }
    .code-btn{
        cursor: pointer;
        color: #757575;
        margin-right: 10px;
    }
    .codeInput{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .codeInput input{
        width: 220px;
    }
</style>


// WEBPACK FOOTER //
// src/view/bindTel.vue